import { Flex, MultiSelectProps, Text } from "@mantine/core";
import { forwardRef, useState } from "react";

import { FKInfoLabel, FKMultiSelect } from "@/features/ui/Base/List/CustomFilter/MultiField";
import { IconX } from "@tabler/icons-react";
import { useItemCategoriesMultiAutoComplete, useItemCategoriesMultiCode } from "./multiAuto-useGetItemCategoriesQuery";

interface ItemCategoryMultiProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string;
    value: string;
}

export interface ItemCategoriesMultiAutoCompleteProps
    extends Partial<MultiSelectProps>,
    Partial<React.RefAttributes<HTMLInputElement>> {
    value: string[];
    onChange?: (e: string[]) => void; // (value: string[]) => React.Dispatch<React.SetStateAction<string>>;
    maxDropdownHeight?: number;
    width?: string;
}

export const ItemCategoriesMultiAutoComplete = (
    params: ItemCategoriesMultiAutoCompleteProps
) => {
    const {
        value: itemCategories,
        onChange,
        maxDropdownHeight,
        width,
        ...etcParams
    } = params;
    const [focused, setFocused] = useState<boolean>(true);
    const [searchKeyword, setSearchKeyword] = useState<string>("");
    const { data: options } = useItemCategoriesMultiAutoComplete(
        focused,
        searchKeyword
    );
    const { data: initialOptions } = useItemCategoriesMultiCode(
        !!searchKeyword,
        searchKeyword ?? null
    );

    const onChangeHandler = (e: string[]) => {
        onChange && onChange(e);
    };

    const SelectItemCategory = forwardRef<HTMLDivElement, ItemCategoryMultiProps>(
        ({ label: name, value: code, ...others }, ref) => (
            <div ref={ref} {...others}>
                <Flex direction="row" justify="space-between" align="center">
                    <Flex align={"center"}>
                        <Text>{name}</Text>
                        <Text fz="xs">(품목분류명: {code})</Text>
                    </Flex>
                </Flex>
            </div>
        )
    );

    return (
        <FKMultiSelect
            clearable
            value={itemCategories}
            data={[...(options ?? []), ...(initialOptions ?? [])].reduce(
                (unique: ItemCategoryMultiProps[], option: ItemCategoryMultiProps) => {
                    return unique.some((u) => u.value === option.value)
                        ? unique
                        : [...unique, option];
                },
                []
            )}
            onChange={onChangeHandler}
            searchable
            itemComponent={SelectItemCategory}
            searchValue={searchKeyword}
            withinPortal
            onDropdownOpen={() => setFocused(true)}
            onDropdownClose={() => setFocused(false)}
            maxDropdownHeight={maxDropdownHeight ?? 150}
            onSearchChange={setSearchKeyword}
            nothingFound="No Options"
            rightSection={ItemCategoryInfo({
                ItemCategory: itemCategories,
                onChange: onChangeHandler,
            })}
            {...etcParams}
        />
    );
};

const ItemCategoryInfo = (params: {
    ItemCategory?: string[];
    onChange: (e: string[]) => void
}) => {
    const { ItemCategory, onChange } = params;

    const clearHandler: React.MouseEventHandler<SVGSVGElement> = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onChange([]);
    };

    return ItemCategory?.length ? (
        <FKInfoLabel>
            <IconX size="1rem" onClick={clearHandler} />
        </FKInfoLabel>
    ) : null;
};

